<template>
  <v-app id="reset">
    <v-main class="background-login">
      <v-container fluid fill-height>
        <v-layout justify-center align-center>
          <v-flex xs12 sm12 md8>
            <v-layout wrap>
              <v-flex xs12 sm12 md6 style="align-content: center">
                <logo />
                <div style="margin: 5%">
                  <v-expansion-panels multiple>
                    <v-expansion-panel class="rounded-xl">
                      <v-expansion-panel-header class="headline pl-12">Reglas para una contraseña segura</v-expansion-panel-header>
                      <v-expansion-panel-content>
                        <v-icon :color="contains_uppercase ? 'green' : 'error'" dark @click="viewRules" small left> mdi-circle </v-icon>
                        <span style="color: #e22d86">Contiene una mayúscula.</span>
                        <br />
                        <v-icon :color="contains_lowercase ? 'green' : 'error'" dark @click="viewRules" small left> mdi-circle </v-icon>
                        <span style="color: #e22d86">Contiene una minúscula.</span>
                        <br />
                        <v-icon :color="contains_number ? 'green' : 'error'" dark @click="viewRules" small left> mdi-circle </v-icon>
                        <span style="color: #e22d86">Contiene un número.</span>
                        <br />
                        <v-icon :color="contains_eight_characters ? 'green' : 'error'" dark @click="viewRules" small left> mdi-circle </v-icon>
                        <span style="color: #e22d86">Contiene entre 8 y 32 carácteres.</span>
                        <br />
                        <v-icon :color="contains_special_character ? 'green' : 'error'" dark @click="viewRules" small left> mdi-circle </v-icon>
                        <span style="color: #e22d86">Contiene carácteres especiales.</span>
                        <br />
                        <v-icon :color="password == password2 && password !== '' && password2 !== '' ? 'green' : 'error'" dark @click="viewRules" small left> mdi-circle </v-icon>
                        <span style="color: #e22d86">Las contraseñas coinciden.</span>
                        <br />
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                  </v-expansion-panels>
                </div>
                <div v-if="rulesPass == true" style="text-align: center"></div>
              </v-flex>
              <v-flex xs12 sm12 md6>
                <v-form @submit.prevent="submit">
                  <v-card class="rounded-xl" color="primary" elevation="5" dark>
                    <v-card-title class="headline pl-5">Reestablecer contraseña</v-card-title>
                    <v-card-text>
                      <v-text-field
                        v-model="password"
                        type="password"
                        :disabled="flag || loading"
                        prepend-icon="mdi-lock"
                        required
                        autocomplete="off"
                        label="Nueva contraseña"
                        @input="checkPassword"
                        @blur="$v.password.$touch()"
                        maxlength="32"
                      >
                      </v-text-field>
                      <div v-if="value">
                        <v-progress-linear v-model="value" :color="value == 20 ? 'error' : value == 40 ? 'orange' : value == 60 ? 'orange' : value == 80 ? 'yellow' : 'green'"></v-progress-linear>
                        <span color="white">
                          {{
                            value == 20
                              ? "Contraseña insegura"
                              : value == 60
                              ? "Contraseña poco segura"
                              : value == 40
                              ? "Contraseña poco segura"
                              : value == 80
                              ? "Contraseña segura"
                              : "Contraseña muy segura"
                          }}
                        </span>

                        <br />
                      </div>
                      <v-text-field
                        v-model="password2"
                        type="password"
                        :disabled="flag || loading"
                        prepend-icon="mdi-lock"
                        required
                        autocomplete="off"
                        label="Repetir contraseña"
                        @input="$v.password2.$touch()"
                        @blur="$v.password2.$touch()"
                        maxlength="32"
                      >
                      </v-text-field>
                    </v-card-text>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn text :disabled="loading" @click="home()">Volver</v-btn>
                      <v-btn type="submit" text :disabled="flag || value < 100" :loading="loading">Enviar</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-form>
                <!-- <errormsg :onFinish="closeMsg" :show="error" :message="codeError" colorMsg="error" alignX="bottom" alignY="right"/> -->
                <v-snackbar v-model="error" color="error" :timeout="2500" bottom right>
                  {{ errorList[codeError] }}
                </v-snackbar>
                <v-snackbar v-model="success" color="success" :timeout="2500" bottom right>
                  {{ msgSuccess }}
                </v-snackbar>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-container>
    </v-main>
    <main-footer />
  </v-app>
</template>

<script>
import { validationMixin } from "vuelidate";
import { required, maxLength } from "vuelidate/lib/validators";
import services from "@/utils/services";
import logo from "@/components/Logo";
import mainFooter from "@/components/Footer";
import errorList from "@/utils/errorsList";

export default {
  name: "reset",
  components: { logo, mainFooter },
  mixins: [validationMixin],
  validations: {
    password: {
      required,
      maxLength: maxLength(50),
    },
    password2: {
      required,
      maxLength: maxLength(50),
    },
  },
  data: () => ({
    loading: false,
    error: false,
    codeError: "",
    success: false,
    rulesPass: false,
    msgSuccess: "",
    solicitud: "",
    password: "",
    password2: "",
    flag: false,
    value: 0,
    bufferValue: 20,
    password_length: 0,
    contains_eight_characters: false,
    contains_number: false,
    contains_uppercase: false,
    contains_lowercase: false,
    contains_special_character: false,
    valid_password: false,
    validLength: false,
    listRules: [
      {
        text: "Debe contener caracteres especiales.",
      },
      {
        text: "Debe contener Mayusculas.",
      },
      {
        text: "Debe contener mas de 8 caracteres.",
      },
      {
        text: "Debe contener numeros.",
      },
    ],
    model: 1,
    errorList,
  }),
  mounted() {
    this.solicitud = this.$route.query.id;
  },
  computed: {
    passwordErrors() {
      const errors = [];
      if (!this.$v.password.$dirty) return errors;
      !this.$v.password.required && errors.push("El campo es obligatorio");
      !this.$v.password.maxLength && errors.push("El campo excede la longitud máxima");
      return errors;
    },
    password2Errors() {
      const errors = [];
      if (!this.$v.password2.$dirty) return errors;
      !this.$v.password2.required && errors.push("El campo es obligatorio");
      !this.$v.password2.maxLength && errors.push("El campo excede la longitud máxima");
      return errors;
    },
  },
  methods: {
    clear() {
      this.$v.$reset();
      this.password = "";
      this.password2 = "";
    },
    submit() {
      this.$v.$touch();
      this.reset();
      if (!this.$v.$invalid && this.password == this.password2 && this.solicitud && this.solicitud !== "") {
        this.reset();
      } else if (!this.solicitud || this.solicitud === "") {
        this.error = true;
        this.codeError = "El id de la solicitud es incorrecto";
      } else if (!this.$v.$invalid) {
        this.error = true;
        this.codeError = "Las contraseñas no coinciden";
      } else {
        this.error = true;
        this.codeError = "Algunos datos del formulario son incorrectos";
      }
    },
    home() {
      this.$router.push("/login");
    },
    viewRules() {
      this.rulesPass = !this.rulesPass;
    },
    reset() {
      this.loading = true;
      let data = {
        data: {
          codigo: this.solicitud,
          password: this.password,
        },
      };
      setTimeout(() => {
        this.axios
          .post(services.routes.reset, data)
          .then(() => {
            this.clear();
            this.success = true;
            this.msgSuccess = "Contraseña actualizada correctamente";
            this.$router.push("/redirect");
          })
          .catch((error) => {
            this.error = true;
            this.codeError = error.response.data.code;
          })
          .finally(() => {
            this.loading = false;
          });
      }, 300);
    },
    closeMsg() {
      this.error = false;
    },
    checkPassword() {
      this.password_length = this.password.length;
      const format = /[ !@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]/;

      if (this.password_length >= 8) {
        this.contains_eight_characters = true;
      } else {
        this.contains_eight_characters = false;
      }
      if (this.validLength != this.contains_eight_characters) {
        this.validLength = this.contains_eight_characters;
        this.validLength ? (this.value += 20) : (this.value -= 20);
      }
      if (format.test(this.password) != this.contains_special_character) {
        format.test(this.password) ? (this.value += 20) : (this.value -= 20);
      }
      if (/\d/.test(this.password) != this.contains_number) {
        /\d/.test(this.password) ? (this.value += 20) : (this.value -= 20);
      }
      if (/[A-Z]/.test(this.password) != this.contains_uppercase) {
        /[A-Z]/.test(this.password) ? (this.value += 20) : (this.value -= 20);
      }
      if (/[a-z]/.test(this.password) != this.contains_lowercase) {
        /[a-z]/.test(this.password) ? (this.value += 20) : (this.value -= 20);
      }
      this.contains_special_character = format.test(this.password);
      this.contains_number = /\d/.test(this.password);
      this.contains_uppercase = /[A-Z]/.test(this.password);
      this.contains_lowercase = /[a-z]/.test(this.password);
      if (this.contains_eight_characters === true && this.contains_special_character === true && this.contains_uppercase === true && this.contains_number === true) {
        this.valid_password = true;
      } else {
        this.valid_password = false;
      }
    },
  },
};
</script>

<style scoped>
.background-login {
  background-color: white !important;
}
v-expansion-panels {
  margin: 1000px;
}
</style>
